<i2g-router-link
  [route]="route"
  [trackingObject]="trackingObject"
  [trackingAction]="trackingAction"
>
  <div [innerHtml]="label | safe: 'html'" class="document-link-wrapper"></div>
</i2g-router-link>
